var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.575c4.418 0 8-3.675 8-8.21 0-4.533-3.582-8.208-8-8.208s-8 3.675-8 8.209 3.582 8.209 8 8.209z",
    stroke: "#2F5FE3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.392c1.105 0 2-.92 2-2.053s-.895-2.052-2-2.052-2 .919-2 2.052c0 1.134.895 2.053 2 2.053zm-4.243 5.13a5.893 5.893 0 018.486 0",
    stroke: "#2F5FE3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarProfile);
export default __webpack_public_path__ + "static/media/navbar_profile.e2a4d8891fc588da8d7864c4159b19a9.svg";
export { ForwardRef as ReactComponent };